import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=2a8e9e43&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"
import style0 from "./Test.vue?vue&type=style&index=0&id=2a8e9e43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e9e43",
  null
  
)

export default component.exports